import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./styles/index.scss";
import ElementUI from 'element-ui';
import 'font-awesome/css/font-awesome.css'
import 'element-ui/lib/theme-chalk/index.css';
import "@/utils/flexible";
import * as echarts from 'echarts'

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false;
Vue.use(Antd);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(ElementUI)

import axios from 'axios'
import "./mock"
import { request } from './api.js';
Vue.prototype.$request = request;

// 全局引入bus，用来做无关组件之间的传值
const Bus = new Vue()
Vue.prototype.Bus = Bus

Vue.use(Vant)
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts
// Vue.prototype.$httpUrl = "http://39.101.76.181:9999"
Vue.prototype.$httpUrl = "http://www.lgsm.com.cn/fser"
Vue.prototype.$backUrl = "http://39.101.76.181"     // 前端地址，扫码付款时的地址
Vue.prototype.$CommunityTitle = "淇泰门锁管理系统"


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
